// extracted by mini-css-extract-plugin
export default {"icon":"SlackConfigContainer-icon-2765892a8b78e27ed286de2c4472c588","button":"SlackConfigContainer-button-dd605026e8747f7cfe67be514f71ea22"};